/**
 * AppFooter — HD (Runde 6)
 *
 * Footer des eingeloggten Bereichs.
 *
 * Nicht uebernommen aus dem v1-Footer: die Partnerzeile "Farming Simulator
 * Mods" (Legacy-Werbeplatz) und die App-Store-Links (im v2-Footer bisher nicht
 * vorhanden, v1-IDs ungeprueft). Discord-/X-Links auf Dennis-Wunsch entfernt
 * (2026-09-02).
 */
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function AppFooter() {
  const { t } = useTranslation('shell')
  const year = new Date().getFullYear()

  return (
    <footer className="app-footer" data-testid="app-footer">
      <div className="app-footer__meta">
        <span data-testid="footer-copyright">{t('footer.copyright', { year })}</span>
        <span aria-hidden="true">·</span>
        <Link to="/legal/imprint" className="app-footer__link" data-testid="footer-imprint">
          {t('footer.imprint')}
        </Link>
        <span aria-hidden="true">·</span>
        {/* Issue #109: Datenschutzerklärung war von nirgendwo verlinkt (nur per
            direkter URL erreichbar) — bei deutscher Nutzerbasis eine
            DSGVO-Pflichtangabe, muss von jeder Seite aus erreichbar sein. */}
        <Link to="/legal/privacy" className="app-footer__link" data-testid="footer-privacy">
          {t('footer.privacy')}
        </Link>
      </div>
    </footer>
  )
}

export default AppFooter
